export const GETDATA_SUCCESS = " GETDATA_SUCCESS";
export const ISFETCHING = " ISFETCHING";
export const RESET_REDUX_DATA = " RESET_REDUX_DATA";
export const ERRORRETRIEVINGINCOMINGLIST = " ERRORRETRIEVINGINCOMINGLIST";
export const ERRORRETRIEVINGCOMPLETEDLIST = " ERRORRETRIEVINGCOMPLETEDLIST";
export const ISREVIEWINPROGRESS = " ISREVIEWINPROGRESS";
export const RESETISOPENREVIEWCLICKED = " RESETISOPENREVIEWCLICKED";
export const GET_OVERDUE_AND_NOTSTARTED_COUNT =
  " GET_OVERDUE_AND_NOTSTARTED_COUNT";
